import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: true
})
export class ClickOutsideDirective {

  @Output() clickedOutside = new EventEmitter();

  constructor(private element: ElementRef) {
  }

  @HostListener('document:click', ['$event'])
  click(event) {
    if (!this.element.nativeElement.contains(event.target)) {
      this.clickedOutside.emit(event);
    } else {
      // console.log('clicked inside');
    }
  }

}
